import { useEffect, useState } from 'react';
import { getMyCourses } from '../services/user/course';

export function useOwnedCourseState() {
  const [state, setState] = useState({ status: 'loading', courses: new Map() });

  useEffect(() => {
    let active = true;
    let requestNumber = 0;

    const loadOwnedCourses = async () => {
      const request = ++requestNumber;
      setState((current) => ({ ...current, status: 'loading' }));
      try {
        const first = await getMyCourses({ page: 1, limit: 100 });
        if (!first?.success) throw new Error('Unable to load enrolled courses');

        const pages = [first];
        const totalPages = Number(first.data?.totalPages) || 1;
        for (let page = 2; page <= totalPages; page += 1) {
          const response = await getMyCourses({ page, limit: 100 });
          if (!response?.success) throw new Error('Unable to load enrolled courses');
          pages.push(response);
        }

        if (active && request === requestNumber) {
          const courses = new Map(
            pages.flatMap((response) => response.data?.courses || [])
              .map((course) => [String(course.course_id), course])
          );
          setState({ status: 'ready', courses });
        }
      } catch (error) {
        if (active && request === requestNumber) {
          setState({ status: 'error', courses: new Map() });
        }
      }
    };

    loadOwnedCourses();
    window.addEventListener('focus', loadOwnedCourses);
    return () => {
      active = false;
      window.removeEventListener('focus', loadOwnedCourses);
    };
  }, []);

  return state;
}

export default function useOwnedCourseIds() {
  const { courses } = useOwnedCourseState();
  return new Set(courses.keys());
}
